import { useEffect, useState } from 'react';

import { RESPONSIVE_SIDEBAR_FLOAT_THRESHOLD } from './use-responsive-siedebar';

const SPLIT_VIEW_MIN_VIEWPORT_WIDTH = RESPONSIVE_SIDEBAR_FLOAT_THRESHOLD + 1;

export const useSplitViewViewportAvailable = () => {
  const [available, setAvailable] = useState(() =>
    typeof window === 'undefined'
      ? true
      : window.innerWidth >= SPLIT_VIEW_MIN_VIEWPORT_WIDTH
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      `(min-width: ${SPLIT_VIEW_MIN_VIEWPORT_WIDTH}px)`
    );
    const updateAvailability = () => setAvailable(mediaQuery.matches);

    updateAvailability();
    mediaQuery.addEventListener('change', updateAvailability);
    return () => {
      mediaQuery.removeEventListener('change', updateAvailability);
    };
  }, []);

  return available;
};
